import React from 'react';
import { styled } from '@linaria/react';
import getPlaceholders from 'components-v3/placeholders/index.js';

const regexes = [
  /([0-7])/,
  /([8-9A-F])/,
  /([G-N])/,
  /([O-V])/,
  /([W-Za-d])/,
  /([e-l])/,
  /([m-s])/,
  /([t-z])/,
];

const Image = styled.img`
  border-radius: 6px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

const OrganizationLogo = ({ orgId = '0', logo, ...props }) => {
  const logoUrl = logo?.url;
  if (logoUrl) return <Image className="organization-switcher__image" width={44} height={44} src={logoUrl} />;

  const placeholders = getPlaceholders('1:1');

  const index = regexes.findIndex(regex => regex.test(orgId[0]));
  const placeholderLogo = placeholders[index] || placeholders[0];

  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {placeholderLogo}
    </svg>
  );
};

OrganizationLogo.propTypes = {

};

export default OrganizationLogo;
